import { connect as reduxConnect } from 'react-redux';
import type { RootState } from '@client/store';
import type { Connect as ReduxConnect } from 'react-redux';

export type Connect = ReduxConnect<RootState>;
export const connect = reduxConnect as Connect;

export type WithDataResponse = { isAdmin: boolean };
